import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import StockList from './components/StockList';
import StockSearch from './components/StockSearch';
import StockChart from './components/StockChart';
import StockNews from './components/StockNews';
import Favorites from './components/Favorites';
import { fetchStocks } from './services/api';

const Home = () => {
  const [stocks, setStocks] = useState([]);
  const [selectedStock, setSelectedStock] = useState('AAPL'); // Set default to AAPL
  const [favorites, setFavorites] = useState(() => JSON.parse(localStorage.getItem('favorites')) || []);

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchStocks();
      setStocks(data);
    };
    fetchData();
  }, []);

  const toggleFavorite = (symbol) => {
    const updatedFavorites = favorites.includes(symbol)
      ? favorites.filter((fav) => fav !== symbol)
      : [...favorites, symbol];
    setFavorites(updatedFavorites);
    localStorage.setItem('favorites', JSON.stringify(updatedFavorites));
  };

  return (
    <Container fluid>
      <h1 className="text-center my-3 h3">Stock Market Dashboard</h1>
      <Row>
        <Col md={3}>
          <StockSearch setSelectedStock={setSelectedStock} stocks={stocks} />
        </Col>
        <Col md={9}>
          <StockList stocks={stocks} favorites={favorites} toggleFavorite={toggleFavorite} setSelectedStock={setSelectedStock} selectedStock={selectedStock}/>
          <Favorites stocks={stocks} favorites={favorites} toggleFavorite={toggleFavorite} setSelectedStock={setSelectedStock} selectedStock={selectedStock} />
          {/*<StockChart symbol={selectedStock} />*/}
          <StockNews symbol={selectedStock} />
        </Col>
      </Row>
    </Container>
  );
};

export default Home;
